package com.appsyde.shared.presentation.screen.component.history

import androidx.compose.runtime.Composable
import com.appsyde.shared.presentation.style.style.AppStylesHistory
import org.jetbrains.compose.web.dom.*

@Composable
fun HistoryModeSelector(
    mode: HistoryContentMode,
    onChange: (HistoryContentMode) -> Unit
) {
    Div(attrs = { classes(AppStylesHistory.historyModeSwitch) }) {
        Button(attrs = {
            classes(AppStylesHistory.historyModeButton)
            if (mode == HistoryContentMode.SUMMARY) classes(AppStylesHistory.historyModeButtonActive)
            onClick { onChange(HistoryContentMode.SUMMARY) }
        }) { Text("Résumé") }

        Button(attrs = {
            classes(AppStylesHistory.historyModeButton)
            if (mode == HistoryContentMode.ORIGINAL) classes(AppStylesHistory.historyModeButtonActive)
            onClick { onChange(HistoryContentMode.ORIGINAL) }
        }) { Text("Originaux") }
    }
}
